import { useEffect } from 'react';
import { loaderRegistry } from './loaderRegistry';

// Marks the page as loading; the shared capsule host (BootLoader) plays the animation.
// full: allow the Capsule Corp loading screen (episode page). Otherwise just the capsule poof.
export const CapsulePageLoader = ({ full = false }) => {
  useEffect(() => loaderRegistry.register(full ? 'full' : 'poof'), [full]);
  return <div className="min-h-screen" data-testid="capsule-page-loader" />;
};

export default CapsulePageLoader;
